'use strict';

exports.__esModule = true;

var _object = require('../helper/object');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SchemaHandler = function () {
  function SchemaHandler(schemaHelper) {
    _classCallCheck(this, SchemaHandler);

    this.schemaHelper = schemaHelper;
  }

  // Abstract


  SchemaHandler.prototype.preProcess = function preProcess() {};

  SchemaHandler.prototype.load = function load(schemaType, schemaVersion, sinks, data, extras, config) {
    this.schemaType = schemaType;
    this.schemaVersion = schemaVersion;
    this.sinks = ['ALL'].concat(sinks);
    this.data = data;
    this.extras = extras ? extras : {};
    this.config = config ? config : {};
    this.preProcess();
    this.process();
  };

  SchemaHandler.prototype.process = function process(sinkFnMap) {
    var _this = this;

    if (this.sinks && this.sinks.length > 0) {
      (0, _object.map)(sinkFnMap, function (sink, fn) {
        if (_this.sinks.indexOf(sink) !== -1) {
          fn(_this.data[sink]);
        }
      });
    }
  };

  return SchemaHandler;
}();

exports.default = SchemaHandler;